import React, { Component } from 'react';



class Menuitem extends Component {
    render() {
        return (
            <div className="row">
                <div className="col-lg-6">
                    <ul className="menu-list m-b0">
                        <li>
                            <div className="menu-item">
                                <h4 className="title">
                                    <span><i className="la la-check-circle-o"></i> Dark Chocolate Cake<small>1 kg</small>
                                    </span>
                                </h4>
                                <p className="price">₹849</p>
                            </div>
                            <p className="description"></p>
                        </li>
                        <li>
                            <div className="menu-item">
                                <h4 className="title">
                                    <span><i className="la la-check-circle-o"></i>Butterscotch, Vanilla Cake<small>1 kg</small></span>
                                </h4>
                                <p className="price">₹649</p>
                            </div>
                            <p className="description"></p>
                        </li>
                        <li>
                            <div className="menu-item">
                                <h4 className="title">
                                    <span><i className="la la-check-circle-o"></i> Rose Pistachio Cake<small>1 kg</small></span>
                                </h4>
                                <p className="price">₹849</p>
                            </div>
                        </li>
                        <li>
                            <div className="menu-item">
                                <h4 className="title">
                                    <span><i className="la la-check-circle-o"></i> Seasonal Fresh Fruit Cake</span>
                                </h4>
                                <p className="price">₹749</p>
                            </div>
                            <p className="description">Depends on fruit base</p>
                        </li>
                        <li>
                            <div className="menu-item">
                                <h4 className="title">
                                    <span><i className="la la-check-circle-o"></i> Black Forest Cake<small>1 kg</small></span>
                                </h4>
                                <p className="price">₹699</p>
                            </div>
                        </li>
                        <li>  <div className="menu-item">
                            <h4 className="title">
                                <span><i className="la la-check-circle-o"></i>Chocolate Customization</span>
                            </h4>
                            <p className="price">₹</p>
                        </div>
                        <p className="description"></p>
                        </li>
                    </ul>
                </div>
                <div className="col-lg-6">
                    <ul className="menu-list">
                        <li>
                            <div className="menu-item">
                                <h4 className="title">
                                    <span><i className="la la-check-circle-o"></i> Belgium 7 Layer Cake<small>1 kg</small></span>
                                </h4>
                                <p className="price">₹1,299</p>
                            </div>
                        </li>
                        <li>
                            <div className="menu-item">
                                <h4 className="title">
                                    <span><i className="la la-check-circle-o"></i> 7 Layer Dream Tin Cake<small>1 kg</small></span>
                                </h4>
                                <p className="price">₹799</p>
                            </div>
                        </li>
                        <li>
                            <div className="menu-item">
                                <h4 className="title">
                                    <span><i className="la la-check-circle-o"></i> Cupcakes<small>each</small></span>
                                </h4>
                                <p className="price">₹25</p>
                            </div>
                        </li>
                        <li>
                            <div className="menu-item">
                                <h4 className="title">
                                    <span><i className="la la-check-circle-o"></i> Brownies<small>Per Piece</small></span>
                                </h4>
                                <p className="price">₹79</p>
                            </div>
                        </li>
                        <li>
                            <div className="menu-item">
                                <h4 className="title">
                                    <span><i className="la la-check-circle-o"></i> Customization</span>
                                </h4>
                                <p className="price">₹</p>
                            </div>
                            <p className="description">Birthday and wedding cakes can be customized with a reference picture.<br/>  No fondant.</p>
                        </li>
                    </ul>
                </div>
            </div>

        )

    }
}

export default Menuitem;